export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  username: {
    value: null,
    maxlength: '70',
    required: true,
    state: null
  },
  email: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  },
  telefoneCelular: {
    value: null,
    maxlength: '20',
    required: true,
    state: null
  },
  senhaAntiga: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  senhaNova: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  confirmacao: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile-form.js